import { AutocompletePredictionsService } from '@bridebook/web/app-shared/lib/search/utils/autocomplete-predictions-service';
import { CustomPredictionService } from '@bridebook/web/app-shared/lib/search/utils/custom-autocomplete-predictions/custom-prediction-service';
import { GooglePlacesService } from '@bridebook/web/app-shared/lib/search/utils/google-places-service';

export const googlePlacesService = new GooglePlacesService();
export const autocompletePredictionsService = new AutocompletePredictionsService(
  new CustomPredictionService(),
  googlePlacesService,
);
